import CommonReactGUIElementsFactory, { ISelectInputProps, IRadioProps, ICheckBoxProps, IDynamicSearchListProps, IDatePickerProps, ITextInputProps, IGUIElementValidation } from "../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsFactory";
import InputValidationsStore from "../../../../commonreact/main/factoryservices/inputvalidation/InputValidationsStore";
import { ELng } from "../../../../language/main/LanguageKeysEnums";

interface IProps {
  ef: CommonReactGUIElementsFactory
}



export default class AppGUIElementsFactory {

  private static _f: AppGUIElementsFactory | null = null;
  public static getFactory(props: IProps): AppGUIElementsFactory {
    // this._keyStart = props.keyStart?props.keyStart:""
    // this._FAddGlobal = props.FAddGlobal;
    if (this._f != null) return this._f; this._f = new AppGUIElementsFactory(props);
    return this._f;
  }

  private static _eKeyWhiteList: string[] = [
    ELng.prop_email.valueOf()
  ]
  private keyIsInWhiteList(key?: string): boolean {
    if (key == undefined) return false;
    if (AppGUIElementsFactory._eKeyWhiteList.find((it) => it == key)) return true;
    return false;
  }

  constructor(private props: IProps) {

  }

  public getSelectInputRequired(props: ISelectInputProps) {
    if (props.required) this.addValidationItemsRequired(props, 0);
    return this.props.ef.getSelectInput(props);
  }

  public getSelectInput(props: ISelectInputProps) {
    if (props.required) this.addValidationItems(props);
    return this.props.ef.getSelectInput(props);
  }

  public getRadios(props: IRadioProps) {
    if (props.required) this.addValidationItems(props);
    return this.props.ef.getRadios(props);
  }

  public getCheckBox(props: ICheckBoxProps) {
    if (props.required) this.addValidationItems(props);
    return this.props.ef.getCheckBox(props);
  }
  

  public getDynamicSearchList<T>(props: IDynamicSearchListProps<T>): JSX.Element {
    this.addValidationItems(props);
    return this.props.ef.getDynamicSearchList(props)
  }

  public getDatePicker(props: IDatePickerProps): JSX.Element {
    if (!props.isReadOnly) this.addValidationItems(props);
    return this.props.ef.getDatePicker(props)
  }

  
  public getTextAreaInput(props: ITextInputProps): JSX.Element {
    if (!props.readOnly) this.addValidationItems(props);
    return this.props.ef.getTextAreaInput(props);
  }

  public getTextAreaInputRequired(props: ITextInputProps, minChars: number = 8): JSX.Element {
    if (!props.readOnly) this.addValidationItemsRequired(props, minChars);
    return this.props.ef.getTextAreaInput(props);
  }


  public getTextInput(props: ITextInputProps): JSX.Element {
    if (!props.readOnly) this.addValidationItems(props);
    return this.props.ef.getTextInput(props);
  }

  public getTextInputRequired(props: ITextInputProps, minChars: number = 8): JSX.Element {
    if (!props.readOnly) this.addValidationItemsRequired(props, minChars);
    return this.props.ef.getTextInput(props);
  }


  private addValidationItems(props: IGUIElementValidation) {
    try {
      if (!this.keyIsInWhiteList(props.label)) return;
      props.validationItems = InputValidationsStore.getItemsByKey(props.label!!,props?.required);
    } catch (e) { }
  }

  private addValidationItemsRequired(props: IGUIElementValidation, minChars: number) {
    try {
      props.validationItems = InputValidationsStore.getItemsByKey("common_required_" + minChars.toString(),props.required);
    } catch (e) {
    }
  }
}